module.exports = __webpack_public_path__ + "img/1481780227.48fd15be.jpg";